import VideoPlayer from "./Video";
import HomeVideo from "../Assets/video/juliana-video-home.mp4";

function Home(props: any) {
  const { data } = props;

  return (
    <div className="home-container container">
      {data.map(
        (
          item: {
            id: string;
            image: string;
            alt: string;
            text: string;
            author: string;
          },
          index: any
        ) => {
          return (
            <div key={index} id={item.id} className="home-content-parent">
              {/* <img src={item.image} alt={item.alt} /> */}
              <VideoPlayer
                src={HomeVideo}
                autoPlay={false}
                controls
                loop={false}
                muted={false}
                className="shadow-lg"
              />
              <div className="home-opacity-box">
                <div className="home-content-child">
                  <p className="animate__animated animate__fadeIn">{item.text}</p>
                  <cite className="animate__animated animate__fadeIn">{item.author}</cite>
                </div>
              </div>
            </div>
          );
        }
      )}
    </div>
  );
}

export default Home;
